import { useMutation } from "@apollo/client"
import { FC, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { Col } from "reactstrap"
import { SAVE } from "../../../../constants"
import { RecruiterDealDrawerProps } from "../../../../interfaces"
import { CREATE, RECRUITER_DEAL_DRAWER_HEADING, UPDATE } from "../../../../utils/constant"
import { formatDealInput } from "../../../../utils/helper"
import { DrawerHeader, Sidedrawer } from "../../../layout/Sidedrawer"
import { CREATE_DEAL, UPDATE_DEAL } from "../gql"
import RecruiterDealForm from "./Form"

const RecruiterDealDrawer: FC<RecruiterDealDrawerProps> = ({ refetch, isOpen, isEdit, recruiterDeal, recruiterId, toggle }) => {
  const [nonRecoverable, setNonRecoverable] = useState<boolean>(false)
  const [underTraining, setUnderTraining] = useState<boolean>(false)
  const [tiersForDeletion, setTiersForDeletion] = useState<string[]>([])
  const [commissionOverwritesForDel, setCommissionOverwritesForDel] = useState<string[]>([])
  const { control, register, setValue, handleSubmit, getValues, reset, formState: { errors } } = useForm()

  // mutations
  const [createDealMutation, { loading }] = useMutation(CREATE_DEAL, {
    onCompleted: (val) => {
      toast.success("Recruiter's Deal Created Successfully")
      toggle()
      refetch()
    },
    onError: () => toast.error("Unable To Create Deal")
  })

  const [updateDealMutation, { loading: updating }] = useMutation(UPDATE_DEAL, {
    onCompleted: (val) => {
      toast.success("Recruiter's Deal Updated Successfully")
      toggle()
      refetch()
    },
    onError: () => toast.error("Unable To Update Deal")
  })

  // useEffect for initiating form when drawer opens
  useEffect(() => {
    setNonRecoverable(Boolean(recruiterDeal?.nonRecoverableDraw))
    setUnderTraining(Boolean(recruiterDeal?.recruiterInTraining))
    if (isOpen && recruiterDeal) {
      reset({
        dealName: recruiterDeal.dealName ?? '',
        recruiterTitle: recruiterDeal.recruiterTitle ?? '',
        dealStartDate: recruiterDeal.dealStartDate ?? '',
        dealEndDate: recruiterDeal.dealEndDate ?? '',
        assignedManagerId: recruiterDeal?.assignedManagerId ? { value: recruiterDeal.assignedManagerId, label: recruiterDeal.assignedManager?.fullName } : null,
        mentorCommission: recruiterDeal?.mentorCommission ?? '',
        nonRecoverableDraw: Boolean(recruiterDeal?.nonRecoverableDraw),
        drawPercentage: recruiterDeal?.drawPercentage?.replaceAll?.(' ', '') ?? '',
        biWeeklySalary: recruiterDeal?.biWeeklySalary ?? '',
        dhBaseRate: recruiterDeal?.dhBaseRate?.replaceAll?.(' ', '') ?? '',
        contractingBaseRate: recruiterDeal?.contractingBaseRate?.replaceAll?.(' ', '') ?? '',
        newClientBonus: recruiterDeal?.newClientBonus?.replaceAll?.(' ', '') ?? '',
      })
    }
  }, [recruiterDeal, isOpen, reset])

  const submitForm = async (values) => {
    const nonRecoverableDraw = values.nonRecoverableDraw ?? nonRecoverable
    const input = formatDealInput(recruiterId, nonRecoverableDraw, underTraining, values)
    if (isEdit) {
      await updateDealMutation({
        variables: {
          input: { dealId: recruiterDeal?.id, tiersForDeletion, commissionOverwritesForDel, ...input }
        }
      })
    } else {
      await createDealMutation({
        variables: {
          input
        }
      })
    }
  }

  return <Sidedrawer isOpen={isOpen} toggle={() => { }}>
    <DrawerHeader
      buttonText={SAVE} disabled={loading || updating} loading={loading || updating} prevClick={toggle} heading={(isEdit ? UPDATE : CREATE) + RECRUITER_DEAL_DRAWER_HEADING}
      nextClick={handleSubmit(submitForm)} />
    <div className="fs-14">
      <Col className="p-0 my-4 ">
        <div className="font-weight-bold">Basic Information</div>
      </Col>
      <RecruiterDealForm recruiterId={recruiterId} setTiersForDeletion={setTiersForDeletion} getValues={getValues}
        tiers={recruiterDeal?.recruiterDealTiers! || []} recruiterDeal={recruiterDeal} underTraining={underTraining}
        nonRecoverable={nonRecoverable} setNonRecoverable={setNonRecoverable} setUnderTraining={setUnderTraining}
        control={control} errors={errors} register={register} setValue={setValue} tiersForDeletion={tiersForDeletion}
        overwrites={recruiterDeal?.commissionOverwrites! || []}
        commissionOverwritesForDel={commissionOverwritesForDel} setCommissionOverwritesForDel={setCommissionOverwritesForDel}

      />
    </div>
  </Sidedrawer>
}
export default RecruiterDealDrawer